module.exports = __webpack_public_path__ + "img/table2.c51199e4.png";